import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uk-container uk-margin uk-flex uk-flex-column uk-flex-center"
}
const _hoisted_2 = { class: "uk-section uk-section-primary" }
const _hoisted_3 = { class: "pdfContainer" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  "uk-grid": "",
  class: "uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-bottom uk-text-left"
}
const _hoisted_7 = { class: "uk-flex uk-flex-center" }
const _hoisted_8 = { class: "uk-text-danger uk-text-large" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf = _resolveComponent("pdf")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AddressInputBlock = _resolveComponent("AddressInputBlock")!
  const _component_SignaturePad = _resolveComponent("SignaturePad")!

  return (!_ctx.mainLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, "Onboarding for " + _toDisplayString(_ctx.onboarderCompany.name), 1),
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.displayDocTypeName(_ctx.docType)), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numPages, (i) => {
            return (_openBlock(), _createBlock(_component_pdf, {
              key: i,
              src: _ctx.pdfLoadingTask,
              page: i,
              style: {"height":"100%"}
            }, null, 8, ["src", "page"]))
          }), 128))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            href: _ctx.docFileUrl,
            target: "_blank"
          }, "Download this document", 8, _hoisted_4)
        ]),
        (_ctx.submitLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("div", {
                "uk-spinner": "ratio: 5",
                class: "uk-padding"
              }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_InputField, {
                  label: "Full Name",
                  modelValue: _ctx.signerName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signerName) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  label: "Your Initials",
                  modelValue: _ctx.signerInitials,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signerInitials) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  label: "Your Title",
                  modelValue: _ctx.signerTitle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signerTitle) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  label: "Date",
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.date) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  label: "Company Name",
                  modelValue: _ctx.carrierInfo.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.carrierInfo.name) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  label: "MC #",
                  modelValue: _ctx.carrierInfo.mcNum,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.carrierInfo.mcNum) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  label: "Phone #",
                  modelValue: _ctx.carrierInfo.dispatchPhone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.carrierInfo.dispatchPhone) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  label: "Fax #",
                  modelValue: _ctx.carrierInfo.faxNumber,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.carrierInfo.faxNumber) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_AddressInputBlock, {
                address: _ctx.carrierInfo.officeAddress
              }, null, 8, ["address"]),
              _createVNode(_component_SignaturePad, { ref: "signaturePad" }, null, 512),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "uk-button uk-button-large uk-button-secondary uk-form-controls uk-margin-top",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goBackToOnboardingPage && _ctx.goBackToOnboardingPage(...args)))
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("div", null, "Go back", -1)
                ]))]),
                _createElementVNode("button", {
                  class: "uk-button uk-button-large uk-button-primary uk-form-controls uk-margin-top",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitSignature && _ctx.submitSignature(...args)))
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("div", null, "Sign", -1)
                ]))])
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.submitError), 1),
              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1))
            ], 64))
      ]))
    : _createCommentVNode("", true)
}